import { render, staticRenderFns } from "./order-page.vue?vue&type=template&id=4f3aec5c"
import script from "./order-page.vue?vue&type=script&lang=js"
export * from "./order-page.vue?vue&type=script&lang=js"
import style0 from "./order-page.vue?vue&type=style&index=0&id=4f3aec5c&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/快电商/preview-qcommerce-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f3aec5c')) {
      api.createRecord('4f3aec5c', component.options)
    } else {
      api.reload('4f3aec5c', component.options)
    }
    module.hot.accept("./order-page.vue?vue&type=template&id=4f3aec5c", function () {
      api.rerender('4f3aec5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/h5/order-page.vue"
export default component.exports